import { render, staticRenderFns } from "./AddAgentMemberDialog.vue?vue&type=template&id=28f2c342"
import script from "./AddAgentMemberDialog.vue?vue&type=script&lang=js"
export * from "./AddAgentMemberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports